import { useStorage, type RemovableRef } from '@vueuse/core';

import { getUserEmail } from '@/api/initial-state';

const PAYMENT_EMAIL_STORAGE_KEY = 'user-payment-email';

type UserState = {
  authEmail: string;
  paymentEmail: string;
  storageEmail: RemovableRef<string>;
};

export const useUserStore = defineStore('user', {
  state(): UserState {
    const authEmail = getUserEmail();
    const paymentEmail = getUserEmail();
    const storageEmail = useStorage(PAYMENT_EMAIL_STORAGE_KEY, authEmail);

    return {
      authEmail,
      paymentEmail,
      storageEmail,
    };
  },

  actions: {
    setPaymentEmail(email: string) {
      this.paymentEmail = email;
    },
    setStorageEmail(email: string) {
      this.storageEmail = email;
    },
  },
});
